import { Button as AntButton, Descriptions, Modal } from 'antd';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IExamineeDetail } from '../../../../../../models/placeTest.model';
import ConfirmModal from '../../../../../modals/ConfirmModal';
import { cancelEntranceExamWithRefundTodo } from '../../../../../../api/refunds.api';
import { cancelEntranceExamWithoutRefund } from '../../../../../../api/placeTest.api';
import useAxios from '../../../../../../hooks/useAxios';
import useNotification from '../../../../../../hooks/useNotification';
import ErrorResponse from '../../../../../ErrorResponse';
import { useHistory } from 'react-router';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  data: IExamineeDetail | undefined;
  doGetExamineeDetail: (platRequireCode: number) => void;
}

const CancelExamModal: FC<IProps> = ({
                                       visible, setVisible, data, doGetExamineeDetail,
                                     }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();
  const { data: res2, isLoading: isLoading2, error: error2, execute: execute2 } = useAxios();
  // const [status, setStatus] = useState('');
  const [confirmCancelVisible, setConfirmCancelVisible] = useState(false);
  const [successCancelVisible, setSuccessCancelVisible] = useState(false);
  const [messageText, setMessageText] = useState('');

  useEffect(() => {
    if (res && !isLoading) {
      if (data?.baseInfo.platRequireCode) {
        doGetExamineeDetail(data?.baseInfo.platRequireCode);
      }

      successNotification(t('common.message.cancel'));
      setConfirmCancelVisible(false);
      setVisible(false);
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      if (data?.baseInfo.platRequireCode) {
        doGetExamineeDetail(data?.baseInfo.platRequireCode);
      }

      successNotification(t('common.message.cancel'));
      setSuccessCancelVisible(true);
      setConfirmCancelVisible(false);
    }
  }, [res2, isLoading2]);

  const confirmCancel = () => {
    if (Number(data?.paymentInfo?.paymentCompleteAmount) > 0) {
      setMessageText(`${Number(data?.paymentInfo?.paymentCompleteAmount)?.toLocaleString()}${t('entrance.schedule.text14')}`);
    } else {
      setMessageText(t('entrance.schedule.text15'));
    }

    setConfirmCancelVisible(true);
  };

  const onCancel = () => {
    if (!data?.baseInfo.platRequireCode) return;

    if (data?.paymentInfo?.paymentCompleteAmount && Number(data?.paymentInfo?.paymentCompleteAmount) > 0) {
      execute2(cancelEntranceExamWithRefundTodo(data?.baseInfo.platRequireCode));
    } else {
      execute(cancelEntranceExamWithoutRefund(data?.baseInfo.platRequireCode));
    }
  };

  return (
    <>
      <ErrorResponse error={error} />
      <Modal
        title={t('entrance.schedule.title10')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <AntButton
              key="submit"
              className="btn-basic pink"
              onClick={confirmCancel}
            >
              {t('entrance.schedule.title10')}
            </AntButton>
            <AntButton
              key="cancel"
              className="btn-basic gray"
              onClick={() => setVisible(false)}
            >
              {t('common.button.close')}
            </AntButton>
          </div>,
        ]}
      >
        <div className="comm-table__area mt-0">
          <Descriptions bordered column={1}>
            <Descriptions.Item label={t('entrance.schedule.column8')}>
              {data?.baseInfo.memberName} ({data?.baseInfo.memberEngName})
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column1')}>
              {moment(data?.baseInfo.examDate).format('YYYY.MM.DD')}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column2')}>
              {data?.baseInfo.srtTime}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column37')}>
              {data?.paymentInfo?.paymentCompleteAmount ? `${Number(data.paymentInfo.paymentCompleteAmount)?.toLocaleString()} ${t('entrance.schedule.text6')}` : '-'}
            </Descriptions.Item>
            <Descriptions.Item label={t('entrance.schedule.column38')}>
              {''/* {status} */}
            </Descriptions.Item>
          </Descriptions>
        </div>

      </Modal>

      {confirmCancelVisible &&
        <ConfirmModal
          visible={confirmCancelVisible}
          setVisible={setConfirmCancelVisible}
          onConfirm={onCancel}
          titleText={t('archive.learn.title4')}
          messageText={messageText}
          confirmText={t('common.option.yes')}
          cancelText={t('common.option.no')}
        />
      }

      {successCancelVisible &&
        <ConfirmModal
          visible={successCancelVisible}
          setVisible={setSuccessCancelVisible}
          onConfirm={() => {
            setSuccessCancelVisible(false);
            history.push(`/student/student?memberCode=${data?.baseInfo?.memberCode}&campusCode=${data?.baseInfo?.campusCode}&tabIndex=4`);
          }}
          titleText={t('archive.learn.title4')}
          messageText={'취소가 완료되었습니다.\n 환불 대상으로 이동 하시겠습니까?'}
          confirmText={t('환불')}
          cancelText={t('common.button.cancel')}
        />
      }
    </>
  );
};

export default CancelExamModal;
